var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "projects" } }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "all", attrs: { to: "/projects" } },
              [_vm._v("ver todos")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(1)
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _vm.featuredProjects && _vm.featuredProjects.length > 0
        ? _c("div", { staticClass: "row list" }, [
            _c("div", { staticClass: "col-md-4 big" }, [
              _vm.featuredProjects[0].Info
                ? _c("div", { staticClass: "project" }, [
                    _c("img", {
                      attrs: { src: _vm.featuredProjects[0].Info.image }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "info" }, [
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.featuredProjects[0].Info.title))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "description" }, [
                            _vm._v(
                              _vm._s(
                                _vm.featuredProjects[0].Info.shortDescription
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: "/project/" + _vm.featuredProjects[0].slug,
                                href: ""
                              }
                            },
                            [_vm._v("Saiba mais")]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4 small" }, [
              _vm.featuredProjects[1].Info
                ? _c("div", { staticClass: "project" }, [
                    _c("img", {
                      attrs: { src: _vm.featuredProjects[1].Info.image }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "info" }, [
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.featuredProjects[1].Info.title))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "description" }, [
                            _vm._v(
                              _vm._s(
                                _vm.featuredProjects[1].Info.shortDescription
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: "/project/" + _vm.featuredProjects[1].slug,
                                href: ""
                              }
                            },
                            [_vm._v("Saiba mais")]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.featuredProjects[2].Info
                ? _c("div", { staticClass: "project" }, [
                    _c("img", {
                      attrs: { src: _vm.featuredProjects[2].Info.image }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "info" }, [
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.featuredProjects[2].Info.title))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "description" }, [
                            _vm._v(
                              _vm._s(
                                _vm.featuredProjects[2].Info.shortDescription
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: "/project/" + _vm.featuredProjects[2].slug,
                                href: ""
                              }
                            },
                            [_vm._v("Saiba mais")]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.featuredProjects[3].Info
                ? _c("div", { staticClass: "project" }, [
                    _c("img", {
                      attrs: { src: _vm.featuredProjects[3].Info.image }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "info" }, [
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.featuredProjects[3].Info.title))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "description" }, [
                            _vm._v(
                              _vm._s(
                                _vm.featuredProjects[3].Info.shortDescription
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: "/project/" + _vm.featuredProjects[3].slug,
                                href: ""
                              }
                            },
                            [_vm._v("Saiba mais")]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4 medium" }, [
              _vm.featuredProjects[4].Info
                ? _c("div", { staticClass: "project" }, [
                    _c("img", {
                      attrs: { src: _vm.featuredProjects[4].Info.image }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "info" }, [
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.featuredProjects[4].Info.title))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "description" }, [
                            _vm._v(
                              _vm._s(
                                _vm.featuredProjects[4].Info.shortDescription
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: "/project/" + _vm.featuredProjects[4].slug,
                                href: ""
                              }
                            },
                            [_vm._v("Saiba mais")]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.featuredProjects[5].Info
                ? _c("div", { staticClass: "project" }, [
                    _c("img", {
                      attrs: { src: _vm.featuredProjects[5].Info.image }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "info" }, [
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.featuredProjects[5].Info.title))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "description" }, [
                            _vm._v(
                              _vm._s(
                                _vm.featuredProjects[5].Info.shortDescription
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: "/project/" + _vm.featuredProjects[5].slug,
                                href: ""
                              }
                            },
                            [_vm._v("Saiba mais")]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e()
            ])
          ])
        : _c("div", { staticClass: "loading-projects" }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c(
                    "span",
                    [
                      _c("font-awesome-icon", {
                        staticClass: "fa-spin",
                        attrs: { icon: ["fas", "spinner"] }
                      }),
                      _c("br"),
                      _vm._v("Carregando ONGs...\n                ")
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _vm._v("\n          Organizações "),
      _c("span", [_vm._v("Sociais")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("ul", { staticClass: "filter d-none" }, [
        _c("li", { staticClass: "active" }, [
          _c("a", { attrs: { href: "" } }, [_vm._v("Recomendadas")])
        ]),
        _vm._v(" "),
        _c("li", [_c("a", { attrs: { href: "" } }, [_vm._v("Novas")])]),
        _vm._v(" "),
        _c("li", [_c("a", { attrs: { href: "" } }, [_vm._v("Mais Visitadas")])])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-beb1a36a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-beb1a36a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/ProjectsSection.vue
// module id = null
// module chunks = 